exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".news-item {\n  background-color: #fff;\n  padding: 20px 30px 20px 80px;\n  border-bottom: 1px solid #eee;\n  position: relative;\n  line-height: 20px;\n}\n.news-item .score {\n  color: #f60;\n  font-size: 1.1em;\n  font-weight: 700;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 80px;\n  text-align: center;\n  margin-top: -10px;\n}\n.news-item .meta,\n.news-item .host {\n  font-size: 0.85em;\n  color: #828282;\n}\n.news-item .meta a,\n.news-item .host a {\n  color: #828282;\n  text-decoration: underline;\n}\n.news-item .meta a:hover,\n.news-item .host a:hover {\n  color: #f60;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/stylus-loader!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Grid.vue?vue&type=style&index=0&id=2de7b714&lang=stylus&
// module id = 520
// module chunks = 1 2